export const SEARCH_BAR_CONFIG = {
  DEFAULT_DEBOUNCE_MS: 300,
  MIN_SEARCH_LENGTH: 0,
  MAX_SEARCH_LENGTH: 100,
  PLACEHOLDER: 'Search by Access or Organization',
  CLEAR_BUTTON_SIZE: 20,
  SEARCH_ICON_SIZE: 14,
  CONTAINER_HEIGHT: 72,
  INPUT_HEIGHT: 40,
  BORDER_RADIUS: 16,
  PADDING: 16,
  GAP: 4
} as const;

export const SEARCH_BAR_STYLES = {
  CONTAINER: `relative flex items-center bg-white border border-gray-200 rounded-[16px] transition-all duration-200 h-[72px] p-4 w-full`,
  CONTAINER_FOCUSED: 'border-blue-500 shadow-sm',
  CONTAINER_DISABLED: 'bg-gray-50 cursor-not-allowed',
  INPUT_CONTAINER: 'relative flex-1 h-[40px]',
  INPUT: 'w-full h-full',
  INPUT_DISABLED: 'cursor-not-allowed text-gray-400',
  SEARCH_ICON: 'w-[14px] h-[14px] transition-colors duration-200',
  SEARCH_ICON_FOCUSED: 'text-[#191F2E]',
  SEARCH_ICON_DEFAULT: 'text-[#191F2E]',
  SEARCH_ICON_DISABLED: 'text-gray-300',
  CLEAR_BUTTON:
    'absolute right-4 top-1/2 transform -translate-y-1/2 flex items-center justify-center w-6 h-6 rounded-full text-gray-400 hover:text-gray-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1',
  BUTTON_CONTAINER: 'ml-4 flex-shrink-0'
} as const;
